// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YSfGz","right":"styles_right__3ItKV"};